import {PropsWithChildren} from "react";
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'
import {WithTheme} from "@yosmanyga/theme";

type MarkdownProps = PropsWithChildren<{

}>

const Markdown = ({
    ...props
}: MarkdownProps) => {
    const {Markdown: BaseMarkdown} = usePrimitives()

    if (!BaseMarkdown) {
        throw new NonExistentPrimitiveError('Markdown')
    }

    return <BaseMarkdown
        {...props}
    />
}

const MarkdownWithTheme = (props: MarkdownProps & UnnormalizedStyleProps) => <WithTheme
    {...props}
    identifier='markdown'
    Component={Markdown}
/>

export default MarkdownWithTheme
